import React, { Fragment, useReducer } from 'react'
import { priceFormat } from './../../../utils/helpers'
import AwardPreviewImage from "./AwardPreviewImage";

const ShowEntries = ({entry, index}) => {
  index = entry.rank ? entry.rank : index + 4
  if (index < 10) {
    index = '0' + index
  }
  let icon = `/images/icon_awards-purple${index}.svg`;
  if (index == '03') {
    icon = '/images/icon_awards-3_m.svg'
  }
  if (index == '02') {
    icon = '/images/icon_awards-2_b.svg'
  }
  if (index == '01') {
    icon = '/images/icon_awards-1_b.svg'
  }
  return (
    <div className="awards-top-seven__item">
      <div className="awards-top-seven-item-image">
        <img
          className="img-top-rank"
          src={icon}
        />
        <AwardPreviewImage entry={entry} className="img-avatar-rank" />
      </div>
      <label className="awards-top-seven-item-name">
        {entry?.user?.nickname}{' '}
      </label>
      <div className="awards-top-seven-item-graph">
        <img
          className="awards-top-seven-item-graph__icon"
          src="/images/icon_vote.svg"
        />
        <label className="awards-top-seven-item-graph__point">
          {priceFormat(entry?.total_vote || 0)}{' '}
        </label>
      </div>
    </div>
  )
}

const AwardTop7 = ({entries = []}) => {
  // true: show
  // false: hide
  const [collapse, setCollapse] = useReducer(p => !p, true)

  return (
    <Fragment>
      <div className="awards-top-seven">
        {collapse && entries.map((entry, key) => 
          <ShowEntries entry={entry} index={key} key={key} />
        )}
      </div>
      <div className="main-awards-action-btn">
        <button className="btn-action active-minus" onClick={setCollapse}>
          <label className="btn-action__icon">{collapse ? '-' : '+'}</label>
          <label className="btn-action__text">{collapse ? '접기' : '더보기'}</label>
        </button>
      </div>
    </Fragment>
  )
}

export default AwardTop7;
